import { post } from '~/plugins/nikan-api'
import Endpoints from '@nikan/endpoints'

export const uploadHandler = (data, callback, url) => { // data => [type:Object]

  // Create Form Data
  let formData = new FormData()
  const fillForm = (data, prefix) => {
    Object.keys(data).forEach((item) => {
      if (!!data[item] && typeof data[item] === 'object' && !(data[item] instanceof File) || Array.isArray(data[item])) {
        fillForm(data[item], `${prefix}${item}.`)
      }
      else
        formData.append(`${prefix}${item}`, data[item])
    })
  }
  fillForm(data, '')
  // Post FormData to url
  return post(Endpoints.getUrl(url), formData, null, { onUploadProgress: callback })
}


export const getUploadedFilesList = (url, entityType, entityId) => {
  return post(Endpoints.getUrl(url), { entityId: entityId, entityType: entityType })
}

export const deleteUploadedFile = (url, entityId) => {
  return post(Endpoints.getUrl(url), { AttachmentId: entityId })
}

export const downloadUploadedFile = (url, entityId, title) => {
  post(Endpoints.getUrl(url), { attachmentId: entityId, }).then((res) => {
    const url = window.URL.createObjectURL(
      new Blob([res.data], { type: res.headers['content-type'] })
    )
    const a = document.createElement('a')
    a.style.display = 'none'
    a.href = url
    console.log('res.headers', res.headers)
    console.log('url', url)
    // the filename you want
    a.download = (title || 'nikan') + (res.headers.extension || '')
    document.body.appendChild(a)
    a.click()
    window.URL.revokeObjectURL(url)
  })
}

export const getAttachmentsCount = (url, entityType, entityId) => {
  return post(Endpoints.getUrl(url), { entityId: entityId, entityType: entityType })
}

export default {
  uploadHandler,
  getUploadedFilesList,
  deleteUploadedFile,
  downloadUploadedFile,
  getAttachmentsCount
}